<template>
    <div class="mt-2">
        <div class="grid grid-cols-5 gap-3">
            <!-- Phase -->
            <div class="col-span-3 col-start-2">
                <label class="font-medium text-md">Set Current Phase</label>
                <el-select v-model="form.ticket_details.phase_id" class="w-full" placeholder="Select Phase" :disabled="form.busy" filterable>
                    <el-option
                        v-for="(phase, index) in ticketPhases"
                        :key="index"
                        :label="phase.phase"
                        :value="phase.id"
                    ></el-option>
                </el-select>
                <span class="text-red-500 text-xs break-normal mt-1" :class="{'d-block': form.errors.has('ticket_details.phase_id')}"
                      v-show="form.errors.has('ticket_details.phase_id')">
                    {{ form.errors.get("ticket_details.phase_id") }}
                </span>
            </div>

            <!-- Reminder Date-->
            <div class="col-span-3 col-start-2">
                <label class="font-medium text-md">To-do Reminder Date</label>
                <el-date-picker
                    :disabled="form.busy"
                    class="w-full"
                    v-model="form.todo.reminder_date"
                    :picker-options="reminderDatePickerOptions"
                    placeholder="Pick A Day"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
                <span class="text-xs text-gray-400">Reminders will show up on the home dashboard as to-dos</span>
                <span class="text-red-500 text-xs break-normal mt-1" v-show="form.errors.has('todo.reminder_date')">
                    {{ form.errors.get("todo.reminder_date") }}
                </span>
            </div>

            <div class="col-span-3 col-start-2" v-if="form.todo.reminder_date">
                <label class="font-medium text-md">To-do Assigned To</label>
                <el-select v-model="form.todo.users" class="w-full"
                           @focus="fetchUsers($event.target.input, portfolioId)"
                           value-key="id"
                           placeholder="Search and select users"
                           filterable
                           collapse-tags
                           multiple>
                    <el-option
                        v-for="user in users"
                        :key="user.id"
                        :label="user.name | capitalize"
                        :value="user">
                    </el-option>
                </el-select>
                <span class="text-red-500 text-xs break-normal mt-1" v-show="form.errors.has('todo.users')">
                    {{ form.errors.get("todo.users") }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import UsersSearch from "../../../mixins/users-search";

export default {
    name: "TicketCreateModalSummary",

    mixins: [UsersSearch],

    props: {
        form: {
            required: true,
            type: Object,
        },
        portfolioId: {
            required: false,
            default: null,
        },
        ticketPhases: {
            required: true,
            type: Array,
            Description: "The ticket phases to choose from"
        },
    },

    computed: {
        reminderDatePickerOptions () {
            let self = this;
            return {
                disabledDate (date) {
                    return date < self.$dayjs().subtract(1, "day");
                }
            };
        },
    },

    created () {
        this.fetchUsers(null, this.portfolioId);
    },
};
</script>
